"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.birchTheme = void 0;
var _colors = require("../../birch/colors");
var birchTheme = exports.birchTheme = {
  "default": {
    borderColor: _colors.FullPalette.GREY_E500,
    hoverBorderColor: _colors.FullPalette.GREY_700,
    textColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    hoverColor: _colors.FullPalette.GREY_E500,
    iconColor: _colors.FullPalette.EVERGREEN_700,
    iconHoverColor: _colors.FullPalette.GREY_E500,
    iconHoverBGColor: _colors.FullPalette.EVERGREEN_700
  },
  error: {
    borderColor: _colors.FullPalette.GREY_E500,
    hoverBorderColor: _colors.FullPalette.POPPY_700,
    textColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    hoverColor: _colors.FullPalette.GREY_E500,
    iconColor: _colors.FullPalette.EVERGREEN_700,
    iconHoverColor: _colors.FullPalette.GREY_E500,
    iconHoverBGColor: _colors.FullPalette.EVERGREEN_700
  },
  selected: {
    borderColor: _colors.FullPalette.EVERGREEN_700,
    hoverBorderColor: _colors.FullPalette.EVERGREEN_700,
    textColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    hoverColor: _colors.FullPalette.GREY_E500,
    iconColor: _colors.FullPalette.EVERGREEN_700,
    iconHoverColor: _colors.FullPalette.GREY_E500,
    iconHoverBGColor: _colors.FullPalette.EVERGREEN_700
  },
  unavailable: {
    borderColor: _colors.FullPalette.GREY_E500,
    hoverBorderColor: _colors.FullPalette.GREY_700,
    textColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    hoverColor: _colors.FullPalette.GREY_E500,
    iconColor: _colors.FullPalette.EVERGREEN_700,
    iconHoverColor: _colors.FullPalette.GREY_E500,
    iconHoverBGColor: _colors.FullPalette.EVERGREEN_700
  }
};